import { Injectable } from '@angular/core';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class ControlPageAssistantService {

  newRooms = new ReplaySubject<{room: Room, modules: Module[]}[]>(1);
  newRooms$ = this.newRooms.asObservable();

  uniqueRoomId = () => `${Math.round(Math.random() * 1000000)}`;
}
